import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'

const SubCategoryEditForm: React.FC<SubCategoryFormProps> = ({
  defaultValues,
  onSubmitEditForm,
  onCancel,
}) => {
  const form = useForm<any>({
    defaultValues: {
      ...defaultValues,
    },
  })

  return (
    <>
      <Form form={form} onSubmit={(values) => onSubmitEditForm(values)}>
        <FormItem
          name="code"
          classes="xl:col-span-3 col-span-3"
          rules={{ required: 'Es necesario el campo' }}
        >
          <InputText small label="Codigo" maxLength={6} />
        </FormItem>

        <FormItem
          name="name"
          classes="xl:col-span-9 col-span-9"
          rules={{ required: 'Es necesario el campo' }}
        >
          <InputText small label="Nombre" maxLength={30} />
        </FormItem>
        <div className="col-span-12 h-full flex flex-row mt-4">
          <div className="w-1/2 mr-5 pl-1">
            <Button
              onClick={() => {
                onCancel()
              }}
              type="outline"
              classes="w-full"
            >
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button type="primary" classes="w-full" htmlType="submit">
              Guardar
            </Button>
          </div>
        </div>
      </Form>
    </>
  )
}

interface SubCategoryFormProps {
  defaultValues?: object | any
  onSubmitEditForm: Function
  onCancel: Function
}

export default SubCategoryEditForm
